import CustomRadio from '../../../../../components/CustomRadio';
import CustomCard from '../../../../../components/CustomCard';
import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param icon Icon: Icon fo field
 * @param string id: Identified of radio field
 * @param string name: Name of radio field
 * @param value: Value of radio field
 * @param boolean checked: Value for checked
 * @param event setSelectionType: Set type selection
 * @param string title: Title section
 * @param string subtitle: Subtitle section
 * @param String classes: Additional classes to apply to the outer wrapper div, usually used to define the height of the card (optional)
 * @param String classContent: Classes to apply to the CardContent section, usually used to define the padding/margin of the card (optional)
 * @param String classCard:  Classes to apply to the Card component, border, background (optional)
 * @param String iconClass: Additional classes to apply to the Icon element.
 */
const ChooseType = (
    {
        Icon, id, name, value,checked, setSelectionType, title, subtitle,
        classes="w-100", classCard="card-border-8px", classContent="p-8px", iconClass="",
    }
) => {

    const { t } = useTranslation();

    return (
        <>
            <CustomCard classes={classes} classCard={classCard} classContent={classContent}>
                <div className="d-flex justify-content-between align-items-center gap-3">
                    <div className="d-flex align-items-center gap-12px">
                        <div className="icons-selection-validation-type">
                            <Icon className={`ic-icons ${iconClass}`} />
                        </div>
                        <div>
                            <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950">{t(`${title}`)}</p>
                            <p className="fs-14-to-13 ibl-font-w-400 font-color-general-950">{t(`${subtitle}`)}</p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <CustomRadio
                            id={id}
                            name={name}
                            value={value}
                            checked={checked}
                            onChange={({ target: { name } }) => {
                                setSelectionType(name)
                            }}
                        />
                    </div>
                </div>
            </CustomCard>
        </>
    )
}

export default ChooseType
